import { useRef, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import {
  AppContext,
  AppContextDefaults,
  IAppContext,
  IProfileContext,
  ProfileContext,
  ProfileContextDefaults,
} from "../contexts/AppContext";

import { AudioContext, IAudioContext } from "../contexts/AudioContext";
import AudioPlayer, { AudioPlayerHandle } from "../components/AudioPlayer";

export function Root() {
  const [data, _setData] = useState<IAppContext>(AppContextDefaults);
  const setData = (d) => _setData({ ...(data || {}), ...(d || {}) });

  const [profile, _setProfile] = useState<IProfileContext>(ProfileContextDefaults);
  const setProfile = (p) => {
    const merge = { ...(profile || {}), ...(p || {}) };
    _setProfile(merge);
  };

  const audioRef = useRef<AudioPlayerHandle>(null);
  const audioContextValue: IAudioContext = {
    play: () => audioRef.current?.play(),
    pause: () => audioRef.current?.pause(),
    setVolume: (v) => audioRef.current?.setVolume(v),
    setSrc: (src) => audioRef.current?.setSrc(src),
    setVisible: (visible) => audioRef.current?.setVisible(visible)
  };

  function bootstrap() {
    setData({ bootstrapped: true });
  }

  if (!data?.bootstrapped) {
    bootstrap();
    return <></>;
  }

  return (
    <Router>
      <AppContext.Provider value={{ ...data, setData }}>
        <ProfileContext.Provider value={{ ...profile, setProfile }}>
          <AudioContext.Provider value={audioContextValue}>
            <AudioPlayer ref={audioRef} />
            {data.bootstrapped ? <App /> : <p>Loading</p>}
          </AudioContext.Provider>
        </ProfileContext.Provider>
      </AppContext.Provider>
    </Router>
  );
}
